module.exports = __webpack_public_path__ + "static/suites-80cb473146edbd02780fdedf2c690103.jpg";